import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import helper from './services/helper';

Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'
//import * as Cookies from 'js-cookie'
import axios from 'axios';

axios.defaults.baseURL = '/ajax';

const getDefaultState = () => {
	return {
		user: {},
		linkedUsers: [],
		transactions: [],
		transactionsShowMore: true,
		transactionsLimit: null,
		transactionsLoading: false,
		linkedUsersLoading: false,
		paymentInstalmentLoading: false,
		paymentActiveCardLoading: false,
		documentsLoading: false,
		addressBookLoading: false,
		userInfoLoading: false,
		chatHistory: [],
		addressBook: [],
		countries: [],
		messages: [],
		faqs: [],
		language: 'en'
	}
};

const store = new Vuex.Store({
	state: getDefaultState(),
    getters: {
        getUserData: state => state.user,
        getTransactions: state => state.transactions,
	    getFAQs: state => state.faqs,
        getTransactionsLoading: state => state.transactionsLoading,
        getChatHistory: state => state.chatHistory,
		getChatHistoryLength: state => state.chatHistory.length,
        getLinkedUsersData: state => state.linkedUsers,
        getPaymentInstalment: state => state.user.instalment || null
    },
    mutations: {
        SAVE_USER_DATA: (state, {user}) => {
            state.user = {...state, ...user};

			state.user.account_balance = state.user.account_balance > 0 ? state.user.account_balance : 0;
		},
		GET_TRANSACTIONS: (state, {data}) => {

			if (!data) {
				data = [];
			}
			state.transactions = data;
		},
	    GET_FAQS: (state, {data}) => {
		    if (!data) {
			    data = [];
		    }
		    state.faqs = data;
	    },
		LOAD_MORE_TRANSACTIONS: (state, payload) => {

			let transactions = [...state.transactions, ...payload];

			let ids = [];
			state.transactions = transactions.filter(function (transaction) {
				if (ids[transaction.id] != transaction.id) {
					ids[transaction.id] = transaction.id;
					return true;
				}
			});

			if (payload.length && payload.length >= state.transactionsLimit) {
				state.transactionsShowMore = true
			} else {
				state.transactionsShowMore = false
			}
		},
		TRANSACTIONS_LOADING: (state, payload) => state.transactionsLoading = payload,
		LINKED_USERS_LOADING: (state, payload) => state.linkedUsersLoading = payload,
	    FAQS_LOADING: (state, payload) => state.faqsLoading = payload,
		FILTER_TRANSACTIONS: (state, payload) => {
			state.transactions = state.transactions.filter((t, num) => num < payload);
		},
		SAVE_CHAT_SESSION: (state, payload) => {
			state.chatHistory = [{...payload}, ...state.chatHistory];
		},
		SAVE_LINKED_USERS: (state, {data}) => {
			state.linkedUsers = data;
		},
		PAYMENT_INSTALMENT_LOADING: (state, payload) => state.paymentInstalmentLoading = payload,
		SAVE_PAYMENT_INSTALMENT: (state, data) => {
			state.user.instalment = {
				term: 999,
				amount: 0
			};
			state.user.instalment.amount = data.instalment;
			state.user.instalment.term = data.instalmentTerm;
		},
		PAYMENT_GET_REGISTERED_ACTIVE_CARD_LOADING: (state, payload) => state.paymentActiveCardLoading = payload,
		SAVE_PAYMENT_REGISTERED_CARD: (state, payload) => state.user.activeCard = payload,
		DOCUMENTS_LOADING: (state, payload) => state.documentsLoading = payload,
		SAVE_DOCUMENTS: (state, payload) => state.user.documents = payload,
		ADDRESS_BOOK_LOADING: (state, payload) => state.addressBookLoading = payload,
		USER_INFO_LOADING: (state, payload) => state.userInfoLoading = payload,
		SAVE_ADDRESS_BOOK: (state, payload) => state.addressBook = payload || [],
		SAVE_COUNTRIES: (state, payload) => state.countries = payload || [],
		SAVE_USER_RESIDENTIAL_ADDRESS: (state, payload) => state.user.addresses.residentialAddressId = payload,
		ADD_MESSAGE: (state, payload) => {
			if (Array.isArray(payload)) {
				payload.forEach(function (item) {
					state.messages.push(item);
				});
			} else {
				if (payload) {
					state.messages.push(payload);
				}
			}
		},
		REMOVE_MESSAGE: (state, payload) => {
			let m = [];
			state.messages.forEach(function (msg, i) {
				if (i !== payload) {
					m.push(msg);
				}
			});
			state.messages = m;
		},
		CLEAR_MESSAGES: (state, payload,) => state.messages = [],
		CLEAR_STATE: (state) => {
			Object.assign(state, getDefaultState());
		},
		CHANGE_LANGUAGE: (state, data) => {
			state.language = data;
		}
	},
	actions: {
		saveUserData: ({commit}, {user}) => {
			commit('GET_TRANSACTIONS', {data: user.transactions});
			delete user.transactions;
			commit('SAVE_USER_DATA', {user});
			commit('SAVE_PAYMENT_INSTALMENT', {
				instalment: (user.instalment ? parseFloat(user.instalment.amount) : 0),
				instalmentTerm: (user.instalment ? parseFloat(user.instalment.term) : 0),
			});
		},
		getTransactions: ({commit}, payload) => {
			commit('TRANSACTIONS_LOADING', true);
			let url = '/api/transactions';
			if (payload && payload.limit) {
				url = url + '?limit=' + payload.limit;
			}

			axios.get(url).then(response => {
				commit('GET_TRANSACTIONS', {data: response.data.transactions});
				commit('TRANSACTIONS_LOADING', false);
			});
		},
		loadMoreTransactions: async ({commit}, {start, end}) => {
			//commit('TRANSACTIONS_LOADING', true);
			/* no need because all transactions are loaded already
			commit('TRANSACTIONS_LOADING', true);
			return await axios.get(`/api/transactions?start=${start}&end=${end}`)
				.then(response => {
					commit('LOAD_MORE_TRANSACTIONS', response.data.transactions);
					commit('TRANSACTIONS_LOADING', false);
					return response;
				});
			 */
		},
		filterTransactions: ({commit}, {limit}) => {
			commit('FILTER_TRANSACTIONS', limit);
		},
		saveChatSession: ({commit}, payload) => {
			commit('SAVE_CHAT_SESSION', payload);
		},
		getLinkedUsers: ({commit}) => {
			commit('LINKED_USERS_LOADING', true);
			let url = '/api/user/accounts';

			axios.get(url).then(response => {
				commit('SAVE_LINKED_USERS', {data: response.data.accounts});
				commit('LINKED_USERS_LOADING', false);
			});
		},
		getPaymentInstalment: ({state, commit}) => {
			commit('PAYMENT_INSTALMENT_LOADING', true);

			return new Promise(function (resolve, reject) {

				if (state.user.hasOwnProperty('instalment')) {
					resolve(state.user.instalment);
					commit('PAYMENT_INSTALMENT_LOADING', false);
				} else {
					axios.get('/api/get-payment-instalment').then(response => {
						commit('SAVE_PAYMENT_INSTALMENT', response.data);
						commit('PAYMENT_INSTALMENT_LOADING', false);
						resolve(state.user.instalment);
					});
				}
			});
		},
		getRegisteredActiveCard: ({state, commit}) => {
			commit('PAYMENT_GET_REGISTERED_ACTIVE_CARD_LOADING', true);
			return new Promise(function (resolve, reject) {
				if (state.user.hasOwnProperty('activeCard') && state.user.activeCard.hasOwnProperty('id') && state.user.activeCard.id) {
					resolve(state.user.instalment);
					commit('PAYMENT_GET_REGISTERED_ACTIVE_CARD_LOADING', false);
				} else {
					axios.get('/api/get-active-card').then(response => {
						commit('SAVE_PAYMENT_REGISTERED_CARD', response.data.activeCard);
						commit('PAYMENT_GET_REGISTERED_ACTIVE_CARD_LOADING', false);
						resolve(state.user.activeCard);
					}).catch(() => {
						commit('PAYMENT_GET_REGISTERED_ACTIVE_CARD_LOADING', false);
					});
				}
			});
		},
		getDocuments: ({commit, state}, payload) => {
			commit('DOCUMENTS_LOADING', true);
			return new Promise(function (resolve, reject) {
				if (state.user.hasOwnProperty('documents')) {
					resolve(state.user.documents);
					commit('DOCUMENTS_LOADING', false);
				} else {
					axios.get('/api/documents').then(response => {
						commit('SAVE_DOCUMENTS', response.data.documents);
						commit('DOCUMENTS_LOADING', false);
						resolve(state.user.activeCard);
					});
				}
			});
		},
		getAddresses: ({commit, state}) => {
			commit('ADDRESS_BOOK_LOADING', true);
			return new Promise(function (resolve, reject) {
				axios.get('/api/address').then(response => {
					commit('SAVE_ADDRESS_BOOK', response.data.results);
					commit('SAVE_COUNTRIES', response.data.countries);
					commit('ADDRESS_BOOK_LOADING', false);
					resolve(state.addressBook);
				}).catch(err => {
					commit('ADDRESS_BOOK_LOADING', false);
				});
			});
		},
		getFAQs: ({commit, state}) => {
			commit('FAQS_LOADING', true);
			axios.post('/api/faqs', {'locale': state.language}).then(response => {
				commit('GET_FAQS', {data: response.data});
				commit('FAQS_LOADING', false);
			});
		},
		addNewAddress: ({commit, state}, payload) => {
			return axios.post('/api/address', {
				...payload
			}).then(response => response).catch((error) => error);
		},
		updateAddress: ({commit, state}, payload) => {
			return axios.post('/api/address/update', {
				floor: payload.floor,
				apartment: payload.apartment,
				house: payload.house,
				street: payload.street,
				city: payload.city,
				county: payload.county,
				postcode: payload.postcode,
				country: payload.country,
				addressId: payload.addressId
			}).then(response => response).catch((error) => console.log('error', error));
		},
		deleteAddress: async ({commit, state}, payload) => {
			let addressToDelete = null;

			let newAddresses = [];

			for (let address of state.addressBook) {
				if (payload == address.id) {
					addressToDelete = address;
					address.loading = true;
				}
				newAddresses.push(address);
			}

			state.addressBook = newAddresses;

			return axios.post('/api/address/delete', {'addressId': addressToDelete.id})
				.then(response => response)
				.catch(err => console.log('err88', err));


		},
		updateUserData: ({commit, state, dispatch}, payload) => {
			commit('USER_INFO_LOADING', true);
			let payloadData = {
				'email': payload ? payload.email : null,
				'phone': payload ? payload.phone : null,
				'addressId': payload ? payload.addressId : null,
			};

			commit('USER_INFO_LOADING', true);
			return axios.post('/api/user', payloadData)
				.then(response => response)
				.catch(err => err)
				.finally(() => commit('USER_INFO_LOADING', false));
		},
		getUserInfo({commit, state}) {
			commit('USER_INFO_LOADING', true);
			return axios.get('/api/user/account-info')
				.then(response => {
					commit('USER_INFO_LOADING', false);
					commit('GET_TRANSACTIONS', {data: response.data.transactions});
					delete response.data.transactions;
					commit('SAVE_USER_DATA', {user: response.data});
				})
				.catch(err => {
					commit('USER_INFO_LOADING', false);
					console.log('err001', err);
					state.user = {};
				})
		},
		setActiveCard: async ({commit, state}, paymentMethodId) => {

			let isPaymentMethodIdFound = false;
			for (let card of state.user.cards) {
				if (card.paymentMethodId == paymentMethodId) {
					isPaymentMethodIdFound = true;
				}
			}

			if (!isPaymentMethodIdFound) {
				return;
			}

			commit('USER_INFO_LOADING', true);

			return axios.post('/api/payment-method/enable', {
				'paymentMethodId': paymentMethodId
			})
				.then(response => response)
				.catch(err => {
					console.log(error);
				}).finally(() => {
					commit('USER_INFO_LOADING', false);
				});

		},
		setNotActiveCard: async ({commit, state}, paymentMethodId) => {
			let isPaymentMethodIdFound = false;
			for (let card of state.user.cards) {
				if (card.paymentMethodId == paymentMethodId) {
					isPaymentMethodIdFound = true;
				}
			}

			if (!isPaymentMethodIdFound) {
				return;
			}
			commit('USER_INFO_LOADING', true);
			return axios.post('/api/payment-method/disable', {
				'paymentMethodId': paymentMethodId
			}).then(response => response).catch(err => {
				console.log(error);
			}).finally(() => {
				commit('USER_INFO_LOADING', false);
			});
		},
		setRevokedCard: async ({commit, state}, paymentMethodId) => {
			let isPaymentMethodIdFound = false;
			for (let card of state.user.cards) {
				if (card.paymentMethodId == paymentMethodId) {
					isPaymentMethodIdFound = true;
				}
			}

			if (!isPaymentMethodIdFound) {
				return new Promise(function (resolve, reject) {
					reject('Payment method not found');
				})
			}
			commit('USER_INFO_LOADING', true);
			return axios.post('/api/payment-method/revoke', {
				'paymentMethodId': paymentMethodId
			})
				.then(response => response)
				.catch(err => error)
				.finally(() => {
					commit('USER_INFO_LOADING', false);
				});
		},
		addNewCard: async ({commit, state}, payload) => {
			commit('USER_INFO_LOADING', true);
			return axios.post('/api/payment-method/add', {
				'cardNumber': payload.card_number,
				'cardCvv': payload.cvv,
				'cardExpiryMonth': payload.expiry_date_month,
				'cardExpiryYear': payload.expiry_date_year,
				'cardNameOnCard': payload.name,
				'cardAddressId': payload.selectedAddressID,
			}).then(response => response).catch(err => {
				console.log(error);
			}).finally(() => {
				commit('USER_INFO_LOADING', false);
			});
		},
		addMessage: ({commit}, payload) => {
			commit('ADD_MESSAGE', payload);
		},
		removeMessages({commit}, payload) {
			commit('CLEAR_MESSAGES');
		},
		removeMessage({commit}, payload) {
			commit('REMOVE_MESSAGE', payload);
		},
		initChatHistory: ({state}) => {
			if (state.chatHistory.length == 0) {
				axios.get('/api/support/chat')
					.then(response => {

						state.chatHistory = response.data.data
					})
					.catch(error => console.log(error));
			}
		},
		clearStore({commit, state}) {
			commit('CLEAR_STATE');
		},
		changeLanguage({commit}, payload) {

			commit('CHANGE_LANGUAGE', payload);
		},
	},
	plugins: [
		createPersistedState({storage: window.localStorage})
	]
});

export default store;


